var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.97 5.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,3.53,9.1,2.28l-3,3.16L2.91,2.21,1.53,3.46,6.06,8Z",
    transform: "translate(-1.53 -2.21)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAlt);
export default __webpack_public_path__ + "static/media/arrow-alt.78fd312e5ed72e99e56d5ac74ae953b9.svg";
export { ForwardRef as ReactComponent };